import LayoutMain    from '@/layouts/_layout_main.vue'
import LayoutDefault from '@/layouts/_layout_default.vue'
import _config       from './plugins/config'

import store   from './store'  // 스토어 인스턴스 생성

const routes = [
  {
    path: _config.LOGOUT_PATH,
    meta: { noAuth: true } ,
    beforeEnter(to, from, next) {
      store.dispatch("session/LOGGED_OUT")
      // next('/')
      next(_config.LOGIN_PATH)
    },
  },
  {
    path: '/', component: LayoutDefault,
    children: [
      // { path: '', name: 'home', component: Home, meta: { noAuth: false } },
      { path: '', redirect: '/qrcode/qrcode_scan' },

      // 로그인
      { meta: { smenu: 'member', noAuth: true }, path: _config.LOGIN_PATH     , component: () => import(/* webpackChunkName:"member" */ './pages/member/login')},
      { meta: { smenu: 'member', noAuth: false }, path: 'member/pw_confirm'    , component: () => import(/* webpackChunkName:"member" */ './pages/member/pw_confirm')},

      // QRCODE
      { meta: { smenu: 'qrcode'   }, path: '/qrcode/qrcode_scan'   ,  component: () => import(/* webpackChunkName:"qrcode"    */ './pages/qrcode/qrcode_scan.vue') },

      // 마이페이지

      { meta: { smenu: 'mypage'  }, path: 'mypage/myinfo'         ,  component: () => import(/* webpackChunkName:"mypage"    */ './pages/mypage/myinfo.vue') },
      { meta: { smenu: 'mypage'  }, path: 'mypage/remote'         ,  component: () => import(/* webpackChunkName:"mypage"    */ './pages/mypage/remote.vue') },
      { meta: { smenu: 'mypage'  }, path: 'mypage/change_pw'      ,  component: () => import(/* webpackChunkName:"mypage"    */ './pages/mypage/change_pw.vue') },
      { meta: { smenu: 'mypage'  }, path: 'mypage/hist_login' ,  component: () => import(/* webpackChunkName:"mypage"    */ './pages/mypage/hist_login.vue') },
      { meta: { smenu: 'mypage'  }, path: 'mypage/hist_qrcode' ,  component: () => import(/* webpackChunkName:"mypage"    */ './pages/mypage/hist_qrcode.vue') },

    ]
  },
  // {
  //   path: '*',
  //   component: () => import(/* webpackChunkName:"common" */ './pages/NotFound'),
  //   meta: { noAuth: true }
  // }
  {
    path: '*',
    component: LayoutMain,
    children: [
      { path: '', component: () => import(/* webpackChunkName:"common" */ './pages/NotFound'), meta: { noAuth: true } },
    ]
  }
]

export default routes